import axios from 'axios';
const url = 'https://api.app-lab.be-keeper.com/plants';
// const url = `${process.env.API}/plants`;

//Plants routes
export const fetchPlants = () => axios.get(url);
export const createPlants = (newPlant) => axios.post(url, newPlant);
export const updatePlant = (id, updatedPlant) => axios.patch(`${url}/${id}`, updatedPlant);
export const deletePlant = (id) => axios.delete(`${url}/${id}`);